export const BASIC_ACCOUNT_MAX_FREE_EVENTS = 5;
export const BASIC_ACCOUNT_MAX_STORAGE = 10;
